import type { ContentLocale } from "@/i18n/config";

export const BRAND_OVERVIEW_LOCALIZED_BASE_PATH_MAP: Record<
  ContentLocale,
  string
> = {
  en: "brands",
  nl: "nl/merken",
  de: "de/marken",
  fr: "fr/marques",
  es: "es/marcas",
  it: "it/marche",
};
